import { StoreModel } from '../store.model';
import { CalculationsExportRowCount } from '../../types/domain/calculations-export-types';

export const isLoadingSelector = (state: StoreModel): boolean => state.calculationsExport.isLoading;

export const errorSelector = (state: StoreModel): string | null => state.calculationsExport.error;

export const exportRowCountSelector = (state: StoreModel): CalculationsExportRowCount | null => state.calculationsExport.exportRowCount;
